import { ContentCluster } from '@app/components/base/content-structure/ContentCluster';
import { Panel } from '@app/components/base/content-structure/Panel';
import { Client } from '@app/core/types/client';
import { User } from '@mi-front/core';
import { List } from '@mui/material';
import { useImpersonation } from '../hooks/useImpersonationStore';
import { impersonationMessages } from '../impersonation-messages';
import { RecentImpersonationUserRow } from './RecentImpersonationUserRow';

type RecentUser = (User & { client: Client }) & {
  lastUsed: number;
};

interface Props {
  onUserSelect: (user: User & { client: Client }) => void;
  onOpenInNewTab: (user: User & { client: Client }) => void;
}

/**
 * Content cluster listing recently impersonated users for one-click re-entry.
 */
export function RecentUsersQuickLogin({ onUserSelect, onOpenInNewTab }: Props) {
  const {
    impersonatedUser: currentUser,
    recentUsers: allRecentUsers,
    removeRecentUser,
  } = useImpersonation();

  const recentUsers = allRecentUsers.filter((user) => user.id !== currentUser?.id);

  function handleUserClick(user: RecentUser) {
    onUserSelect(user);
  }

  function handleUserDelete(userId: string, event: React.MouseEvent) {
    event.stopPropagation();
    removeRecentUser(userId);
  }

  if (recentUsers.length === 0) {
    return null;
  }

  return (
    <ContentCluster message={impersonationMessages.recentUsersTitle}>
      <Panel>
        <List disablePadding dense>
          {recentUsers.map((user) => (
            <RecentImpersonationUserRow
              key={user.id}
              user={user}
              onSelect={handleUserClick}
              onOpenInNewTab={onOpenInNewTab}
              onDelete={handleUserDelete}
            />
          ))}
        </List>
      </Panel>
    </ContentCluster>
  );
}
